import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'news';
@Injectable({
    providedIn: 'root'
})
export class NewsService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getNewsList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getNewsDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    updateNews(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata);
    }
    addNews(newsdata): Observable<any> {
        return this.http.post(API_URL, newsdata);
    }
    uploadNewsCsv(csvData): Observable<any> {
        return this.http.post(API_URL + '/uploadCSV', csvData);
    }
    uploadNewsImages(imagesData): Observable<any> {
        return this.http.post(API_URL + '/uploadImages', imagesData);
    }
}